import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=1c610f7d&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c610f7d",
  null
  
)

export default component.exports